export default __webpack_public_path__ + "static/media/notification_sound.e7e8aabb.mpeg";